import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AccordionFieldExtension } from './extensions/AccordionField/extensions';
import { CustomRepoUrlPickerFieldExtension } from './extensions/CustomRepoUrlPicker/extensions';
import { GitLabProjectPickerFieldExtension } from './extensions/GitLabProjectPicker/extensions';
import { PasswordGeneratorFieldExtension } from './extensions/PasswordGenerator/extensions';
import { ServiceBusTopicManagerFieldExtension } from './extensions/ServiceBusTopicManager/extensions';
import { ZipUploadPickerFieldExtension } from './extensions/ZipUploadPicker/extensions';

export const scaffolderModuleAllosFields = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    AccordionFieldExtension,
    CustomRepoUrlPickerFieldExtension,
    GitLabProjectPickerFieldExtension,
    PasswordGeneratorFieldExtension,
    ServiceBusTopicManagerFieldExtension,
    ZipUploadPickerFieldExtension,
  ],
});
